import { render, staticRenderFns } from "./CatalogProductAssignedApplications.vue?vue&type=template&id=7f48871a&scoped=true&"
import script from "./CatalogProductAssignedApplications.vue?vue&type=script&lang=js&"
export * from "./CatalogProductAssignedApplications.vue?vue&type=script&lang=js&"
import style0 from "./CatalogProductAssignedApplications.vue?vue&type=style&index=0&id=7f48871a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f48871a",
  null
  
)

export default component.exports